import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {API_ENDPOINT} from '../config';

const STATUS_LABELS = {
    queued: 'În coadă',
    running: 'Se generează',
    success: 'Reușit',
    failed: 'Eșuat',
};

const formatEntry = (item) => {
    const date = new Date(item.requestedAt);
    const dateStr = date.toLocaleDateString('ro-RO');
    const timeStr = date.toLocaleTimeString('ro-RO', {hour: '2-digit', minute: '2-digit'});
    const statusLabel = STATUS_LABELS[item.status] || item.status;
    return `${dateStr}:${timeStr} - ${statusLabel}`;
};

/**
 * Ultimele 3 generari APK, de pe toata platforma (public - vezi StatsController).
 * Reutilizata in Navbar (dropdown notificari) si Dashboard (panel).
 */
export const useRecentGenerations = () => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        axios.get(`${API_ENDPOINT}/v1/stats/recent-generations`)
            .then(({data}) => setItems(data || []))
            .catch(() => setItems([]));
    }, []);

    return items;
};

export const formatRecentGeneration = formatEntry;
